import React, { Fragment } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { createStyles, makeStyles, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { LoginStepValues } from "../../_interfaces/IOrganizationSignUpStepTypeValues";
import { IOrganizationSignUpFlowValues } from "../../_interfaces/IOrganizationSignUpFlowValues";
import { useLoginController } from "../../hooks/useLoginController";
import { LoginForm } from "../../../../authentication/components/LoginForm";
import { OrganizationSignUpHeader } from "../OrganizationSignUpHeader";
import { BackButton } from "./BackButton";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            color: theme.palette.action.active,
            marginBottom: theme.spacing(4),
            textAlign: 'center'
        },
        wrapper: {
            maxWidth: `calc(40ch + ${theme.spacing(2)}px)`,
            margin: 'auto'
        },
    })
);

export const LoginStep: React.FC<
    StepRenderProps<LoginStepValues, IOrganizationSignUpFlowValues>
> = observer(({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

    /********* React hooks *********/

    const classes = useStyles();
    const controller = useLoginController(values, allValues, update, submit);

    /********* Render *********/

    return (
        <Fragment>
            <OrganizationSignUpHeader />
            <div className={classes.title}>
                <Typography variant="h5">Log into your account.</Typography>
            </div>
            <div className={classes.wrapper}>
                <LoginForm
                    values={controller.values}
                    onChange={(patch) => {
                        controller.onChange(patch);
                        update(patch); // sync with Flow
                    }}
                    onSubmit={controller.onSubmit}
                    isSubmitting={controller.isSubmitting}
                    error={controller.error}
                    fieldErrors={controller.fieldErrors}
                />
            </div>
            <BackButton
                onClicked={() => controller.onSubmit({ backClicked: true })}
                isSubmitting={controller.isSubmitting}
            />
        </Fragment>
    );
});